import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faTools } from '@fortawesome/free-solid-svg-icons';
import './DiscountSubsite.css';

const DiscountSubsite: React.FC = () => {
  return (
    <div className="discount-page-wrapper">
      <Container className="text-center" style={{ maxWidth: '800px' }}>
        
        <div className="discount-icon-wrapper mb-4">
          <FontAwesomeIcon icon={faTools} size="4x" className="tools-icon" />
        </div>
        
        <h1 className="discount-title mb-3">Zmieniamy się dla Was!</h1>
        
        <p className="discount-description mb-5">
          Pracujemy nad specjalną ofertą. Już niedługo znajdziesz tutaj wyselekcjonowane, promocyjne nagrania, które pomogą Ci rozwinąć kompetencje.
        </p>

        <div className="discount-social-section">
          <p className="social-lead-text mb-4">
            Na ten czas, skorzystaj i zobacz nasze najnowsze treści na:
          </p>
          
          <div className="d-flex justify-content-center gap-4 flex-wrap">
            <a 
              href="https://www.facebook.com/pccporada"
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-btn facebook-btn"
            >
              <FontAwesomeIcon icon={faFacebookF} className="me-2" />
              Odwiedź Facebook
            </a>
            
            <a 
              href="https://www.youtube.com/@pccpoland" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-btn youtube-btn"
            >
              <FontAwesomeIcon icon={faYoutube} className="me-2" />
              Odwiedź YouTube
            </a>
          </div>
        </div>

      </Container>
    </div>
  );
};

export default DiscountSubsite;